import { render } from "./InputTest.vue?vue&type=template&id=ae37fa20"
import script from "./InputTest.vue?vue&type=script&lang=js"
export * from "./InputTest.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__